import {call, put, takeEvery} from "redux-saga/effects";
import {CommonService} from "../../shared/services";
import {
    GET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION,
    GET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION,
    GET_CLIENT_BASIC_DETAILS,
    GET_CLIENT_CASE_DETAILS,
    GET_CLIENT_COMMUNICATION_REFERRAL_DETAILS,
    GET_CLIENT_INJURY_DETAILS,
    GET_CLIENT_MEDICAL_HISTORY_DETAILS,
    GET_CLIENT_SIGNATURE_DETAILS,
    GET_SERVICE_LIST,
    setClientAuthorizationDiscloseProtectedHealthInformation,
    setClientAuthorizationToReleaseInformation,
    setClientBasicDetailsFailed,
    setClientCaseDetails,
    setClientCommunicationReferralDetailsFailed,
    setClientCommunicationReferralDetailsSuccess,
    setClientInjuryDetails,
    setClientMedicalHistoryDetailsFailed,
    setClientMedicalHistoryDetailsSuccess,
    setClientSignatureDetails,
    setServicesList
} from "../actions/client.action";

function* getClientBasicDetails() {
    try {
        // @ts-ignore
        const resp = yield call(CommonService._client.GetPersonalDetailsAPICall);
        yield put(setClientBasicDetailsFailed(resp?.data));
    } catch (error: any) {
        yield put(setClientBasicDetailsFailed(error));
    }
}

function* getClientCommunicationReferralDetails() {
    try {
        // @ts-ignore
        const resp = yield call(CommonService._client.GetClientCommunicationReferralDetailsAPICall);
        yield put(setClientCommunicationReferralDetailsSuccess(resp?.data));
    } catch (error: any) {
        yield put(setClientCommunicationReferralDetailsFailed(error));
    }
}

function* getClientMedicalHistoryDetails() {
    try {
        // @ts-ignore
        const resp = yield call(CommonService._client.GetClientMedicalHistoryDetailsAPICall);
        yield put(setClientMedicalHistoryDetailsSuccess(resp?.data));
    } catch (error: any) {
        yield put(setClientMedicalHistoryDetailsFailed(error));
    }
}

function* getClientCaseDetails(action: any) {
    try {
        // @ts-ignore
        const resp = yield call(CommonService._client.ClientCaseDetailsAPICall, action.payload.caseId);
        yield put(setClientCaseDetails(resp?.data || []))
    } catch (error: any) {
        yield put(setClientCaseDetails([]))
    }
}

function* getClientInjuryDetails(action: any) {
    try {
        // @ts-ignore
        const resp = yield call(CommonService._client.GetClientFirstInjuryFormDetailsAPICall, action.payload);
        yield put(setClientInjuryDetails(resp?.data || []))
    } catch (error: any) {
        yield put(setClientInjuryDetails([]))
    }
}

function* getClientAuthorizationDetails(action: any) {
    try {
        // @ts-ignore
        const resp = yield call(CommonService._client.getClientFirstAuthorizationForm, action.payload);
        yield put(setClientAuthorizationToReleaseInformation(resp?.data || null));
    } catch (error: any) {
        yield put(setClientAuthorizationToReleaseInformation(null));
    }
}

function* getAuthorizationDiscloseProtectedHealthInformation(action: any) {
    try {
        // @ts-ignore
        const resp = yield call(CommonService._client.getAuthorizationDiscloseProtectedHealthInformation, action.payload.initialAppointmentId);
        console.log(resp);
        yield put(setClientAuthorizationDiscloseProtectedHealthInformation(resp?.data || null));

    } catch (error: any) {
        yield put(setClientAuthorizationDiscloseProtectedHealthInformation(null));
    }
}


function* getClientSignatureDetails(action: any) {
    try {
        // @ts-ignore
        const resp = yield call(CommonService._client.getClientSignatureDetails, action.payload.isOnboarded, action.payload.initialAppointmentId);
        yield put(setClientSignatureDetails(resp?.data || null));
    } catch (error: any) {
        yield put(setClientSignatureDetails(null));
    }
}

function* getAllServicesList() {
    try {
        // @ts-ignore
        const resp = yield call(CommonService._client.getAllServicesList);
        yield put(setServicesList(resp?.data || []))
    } catch (error: any) {
        yield put(setServicesList([]))
    }
}

export default function* clientSaga() {
    yield takeEvery(GET_CLIENT_BASIC_DETAILS, getClientBasicDetails);
    yield takeEvery(GET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION, getAuthorizationDiscloseProtectedHealthInformation);
    yield takeEvery(GET_CLIENT_COMMUNICATION_REFERRAL_DETAILS, getClientCommunicationReferralDetails);
    yield takeEvery(GET_CLIENT_MEDICAL_HISTORY_DETAILS, getClientMedicalHistoryDetails);
    yield takeEvery(GET_CLIENT_CASE_DETAILS, getClientCaseDetails);
    yield takeEvery(GET_CLIENT_INJURY_DETAILS, getClientInjuryDetails);
    yield takeEvery(GET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION, getClientAuthorizationDetails)
    yield takeEvery(GET_CLIENT_SIGNATURE_DETAILS, getClientSignatureDetails);
    yield takeEvery(GET_SERVICE_LIST, getAllServicesList);
}
